module.exports = __webpack_public_path__ + "static/media/arrowDown.f8db200e.svg";